import React, { useEffect, useState } from "react";
import { getAdminToken, adminLoginFromSession } from "../utils/adminAuth";

/*
  Shared "unlock this Admin Panel section" gate. See adminAuth.js /
  admin_session_from_login.php: access is unlocked automatically for
  anyone already logged in to the main site — no separate password.
  Still not a real role/permission system — every logged-in customer can
  get through this. Replace with a real `role`/`is_admin` check once
  that exists.
*/
export default function AdminSectionGate({ personaluid, children }) {
    const [status, setStatus] = useState(getAdminToken() ? "ready" : "checking"); // checking | ready | denied

    useEffect(() => {
        if (getAdminToken()) { setStatus("ready"); return; }
        if (!personaluid) { setStatus("denied"); return; }
        let cancelled = false;
        adminLoginFromSession(personaluid).then((res) => {
            if (!cancelled) setStatus(res.success ? "ready" : "denied");
        });
        return () => { cancelled = true; };
    }, [personaluid]);

    if (status === "checking") return <div className="p-3">Checking access...</div>;
    if (status === "denied") return <div className="alert alert-danger m-3">Could not verify your login. Please log out and back in, then try again.</div>;
    return children;
}
